// This file is like a css file but for MUI components. Import this to your MUI page to change the theme (other steps involved also). 

import '../index.js'
import '../index.css'
import { createTheme } from '@mui/material/styles';

import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';

const ResearchTheme = createTheme({
  palette: {
    primary: {
      main: '#649470',
    },
    secondary: {
      main: '#e0f0e4',
    },
  },
  typography: {
    fontFamily: 'Poppins',
  },
  // Override component styles
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Example of overriding button text transformation
        },
      },
    },
  },
});

export default ResearchTheme;
